import { NamedRts } from "@/router";

export const routeParamsBuilder = () => {
  return {
    mWorkOrderTasks: (id: string) => {
      return {
        name: NamedRts.mWorkOrderTasks,
        params: {
          workOrderId: id,
        },
      };
    },
    workOrderNotes: (id: string) => {
      return {
        name: NamedRts.mWorkOrderNotes,
        params: {
          workOrderId: id,
        },
      };
    },
    buildWorkOrder: (id: string) => {
      return {
        name: NamedRts.buildWorkOrder,
        params: {
          workOrderId: id,
        },
      };
    },
    buildTruckLoad: (id: string) => {
      return {
        name: NamedRts.buildTruckLoad,
        params: {
          truckLoadId: id,
        },
      };
    },
    templateWorkOrderEditForm: (id: string) => {
      return {
        name: NamedRts.templateWorkOrderEditForm,
        params: {
          templateWorkOrderId: id,
        },
      };
    },

    templateWorkOrders: {
      name: NamedRts.templateWorkOrders,
    },
    trucks: {
      name: NamedRts.trucks,
    },
    truckLoads: {
      name: NamedRts.truckLoads,
    },
    workOrderCreateForm: {
      name: NamedRts.workOrderCreateForm,
    },
    workOrders: {
      name: NamedRts.workOrders,
    },
    truckLoadReports: {
      name: NamedRts.truckLoadReports,
    },
    workOrderTasks: {
      name: NamedRts.workOrderTasks,
    },
    workOrderPrint: {
      name: NamedRts.workOrderPrint,
    },
    workOrderDetails: {
      name: NamedRts.workOrderDetails,
    },
    workOrderInstructions: {
      name: NamedRts.workOrderInstructions,
    },
    workOrderInstructionEditForm: (workOrderId: string, id: string) => {
      return {
        name: NamedRts.workOrderInstructionEditForm,
        params: {
          workOrderId: workOrderId,
          workOrderInstructionId: id,
        },
      };
    },
    billingDashboard: {
      name: NamedRts.billingDashboard,
    },
    productivityDashboard: {
      name: NamedRts.productivityDashboard,
    },
    calendarSchedule: {
      name: NamedRts.calendarSchedule,
    },
    sellContracts: {
      name: NamedRts.sellContracts,
    },
    sellContractDetails: {
      name: NamedRts.sellContractDetails,
    },
    sellContractIlsctlLineItems: {
      name: NamedRts.sellContractIlsctlLineItems,
    },
    sellContractPrint: {
      name: NamedRts.sellContractPrint,
    },
    inventoryLots: {
      name: NamedRts.inventoryLots,
    },
    inventoryLotDetails: {
      name: NamedRts.inventoryLotDetails,
    },
    inventoryLotIlsctlLineItems: {
      name: NamedRts.inventoryLotIlsctlLineItems,
    },
    inventoryLotPrint: {
      name: NamedRts.inventoryLotPrint,
    },
    clients: {
      name: NamedRts.clients,
    },
    lotUnits: {
      name: NamedRts.lotUnits,
    },
    lineItems: {
      name: NamedRts.lineItems,
    },
    clientFields: {
      name: NamedRts.clientFields,
    },
    commodities: {
      name: NamedRts.commodities,
    },
    users: {
      name: NamedRts.users,
    },
    inventoryLotNew: {
      name: NamedRts.inventoryLotEditForm,
      params: {
        inventoryLotId: "new",
      },
    },
    sellContractNew: {
      name: NamedRts.sellContractEditForm,
      params: {
        sellContractId: "new",
      },
    },
    commodityInventorySummaries: {
      name: NamedRts.commodityInventorySummaries,
    },
    workQueue: {
      name: NamedRts.workQueue,
    },

    mWorkQueue: {
      name: NamedRts.mWorkQueue,
    },
    mLogIn: {
      name: NamedRts.mLogIn,
    },
  };
};
